import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class CityService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
             ) { }

    getCity(isActive:number=-1) {

        let isAvailable: string ="?active="+isActive;

        if(isActive==-1){
            isAvailable="";
        }

        return this.http.get(this.global.httpUrl+"cities"+isAvailable);
    }

    getCityById(id: any) {
        return this.http.get(this.global.httpUrl+"cities/"+id);
    } 

    createCity(data: any){
        return this.http.post(this.global.httpUrl+"cities", data); 
    }

    updateCity(data: any,id: any){
        return this.http.put(this.global.httpUrl+"cities/"+id, data); 
    } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/cities/city.service.ts